import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  typeForEdit: {
    id: undefined,
    name: "",
    title: "",
    sellerFee: "",
    feature: "",
    description: "",
    price: "",
    iconUrl: "",
  },
  message: null,
  messageType: null,
  showMessage: false,
  stateData: {},
  selectedTab: 0,
  typeId: undefined,
  showtypePopover: false,
  showDeleteDialog: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const typeSlice = createSlice({
  name: "logistictype",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // category loader
    typeListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    typeList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadtypeForEdit: (state, action) => {
      const payload = action.payload;

      state.typeForEdit.name = payload.name;
      state.typeForEdit.id = payload.id;
      state.typeForEdit.title = payload.title;
      state.typeForEdit.sellerFee = payload.sellerFee;
      state.typeForEdit.feature = payload.feature;
      state.typeForEdit.description = payload.description;
      state.typeForEdit.price = payload.price;
      state.typeForEdit.iconUrl = payload.iconUrl;
    },
    loadTypeMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
    loadState: (state, action) => {
      state.stateData = action.payload;
    },
    setTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    openTypeApprove: (state, action) => {
      const { typeId } = action.payload;

      state.typeId = typeId;
      state.showTypePopover = !state.showTypePopover;
    },
    setDeleteDialogData: (state, action) => {
      state.showDeleteDialog = !state.showDeleteDialog;
      state.typeId = action.payload;
    },
  },
});
